import React, { useContext } from "react";
var SsrContext = /*#__PURE__*/React.createContext({
  isSsr: false,
  ssrScreenWidth: 0
});
/**
 * Возвращает значения контекста SsrContext:
 *
 * isSsr - true при рендере на сервере и при первом рендере (hydrate) на клиенте.
 *
 * ssrScreenWidth - "ширина" экрана. Например, определяемая путем парсинга типа устройства из user-agent (mobile/tablet/desktop).
 */

export var useSsr = function useSsr() {
  var context = useContext(SsrContext);
  return context;
};
var SsrProvider = SsrContext.Provider;
export default SsrProvider;